/**
 * 智配新鲜度算法：根据 lastUpdate 输出温度标签
 * @param {string} lastUpdate - 后端返回的 YYYY-MM-DD HH:mm:ss
 */
export function useRelativeTime(lastUpdate) {
  const raw = String(lastUpdate || '').trim()
  if (!raw) {
    return { text: '未检测', tone: 'info', showRefresh: true, diffSeconds: null }
  }

  // Safari/部分浏览器不稳定解析 "YYYY-MM-DD HH:mm:ss"，统一转 ISO-ish
  const isoLike = raw.replace(' ', 'T')
  const updateTime = new Date(isoLike)
  const now = new Date()
  const diffSeconds = Math.floor((now.getTime() - updateTime.getTime()) / 1000)

  if (!Number.isFinite(diffSeconds)) {
    return { text: raw, tone: 'info', showRefresh: true, diffSeconds: null }
  }

  if (diffSeconds < 60) {
    return { text: '刚刚', tone: 'success', showRefresh: false, diffSeconds }
  }
  if (diffSeconds < 1800) {
    const mins = Math.floor(diffSeconds / 60)
    return { text: `${mins} 分钟前`, tone: 'info', showRefresh: false, diffSeconds }
  }
  const mins = Math.floor(diffSeconds / 60)
  return { text: `检测于 ${mins} 分钟前`, tone: 'warning', showRefresh: true, diffSeconds }
}

export function datePartFromLastUpdate(lastUpdate) {
  const raw = String(lastUpdate || '').trim()
  // "2026-04-09 16:15:00" -> "2026-04-09"
  if (raw.length >= 10) return raw.slice(0, 10)
  return ''
}

